import { serviceName } from '../resources/serviceConstants';
import {
  DEAL_ROLE_MASTER,
  ENABLE_OR_DISABLE_DEAL_ROLE,
} from '../resources/endPoint';

export const dealRoleList = () => {
  // API call to fetch role list
  return {
    url: DEAL_ROLE_MASTER,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.ROLES_MS,
  };
};

export const enableOrDisabledealRole = (data) => {
  // API call to fetch role list
  return {
    url: ENABLE_OR_DISABLE_DEAL_ROLE,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.ROLES_MS,
  };
};

